/**
 * Configure PDF.js worker for ng2-pdf-viewer (pdfjs-dist 4.x).
 * The legacy Angular 14 setup pointed to an old assets/utils/pdf.worker.js
 * which crashes with the current pdfjs version.
 */
export function setupPdfWorker(): void {
    (window as any).pdfWorkerSrc = '/assets/utils/pdf.worker.min.mjs';
}
